import { ConvexReactClient, ConvexProviderWithAuth } from "convex/react";
import { useConvexAuth } from "./auth-machine";

const convexUrl = import.meta.env.VITE_CONVEX_URL;

const convex = new ConvexReactClient(convexUrl);

interface SessionKeyedConvexProviderProps {
  children: React.ReactNode;
}

/**
 * Convex provider that passes JWT tokens via ConvexProviderWithAuth.
 * Auth state and token fetching are managed by the auth state machine.
 */
export function SessionKeyedConvexProvider({ children }: SessionKeyedConvexProviderProps) {
  return (
    <ConvexProviderWithAuth client={convex} useAuth={useConvexAuth}>
      {children}
    </ConvexProviderWithAuth>
  );
}

// Re-export useSessionId from auth-machine for backward compatibility
export { useSessionId } from "./auth-machine";
